import type { ReactNode } from "react";
import { useSiteSummary } from "../../api/sites";
import { useMe } from "../../auth/session";
import { SubTabs, type SubTab } from "../../components/ui";

/** Sites | Exceptions | Red List: the strip under the masthead on all three
 * screens, each tab with its count, so the office sees how much is waiting on
 * the other two without leaving the one it is on.
 *
 * `sitesTo` is where the Sites tab points. The register's tab has to read as
 * current while a site's drawer is open at `/sites/:id`, but a prefix match
 * would also light it on `/sites/redlist`; so the register passes the address
 * it is showing and the tab matches exactly that. Exceptions is drawn only for
 * an account that may open it, as the shell draws its own nav. */
export default function SectionTabs({ sitesTo = "/sites", end }: { sitesTo?: string; end?: ReactNode }) {
  const summary = useSiteSummary();
  const me = useMe();
  const counts = summary.data;
  const mayOpenExceptions = (me.data?.screens ?? []).some((screen) => screen.key === "exceptions");
  const tabs: SubTab[] = [
    { to: sitesTo, label: "Sites", count: counts?.sites },
    ...(mayOpenExceptions
      ? [
          {
            to: "/exceptions",
            label: "Exceptions",
            count: counts?.exceptions,
            countTone: counts !== undefined && counts.exceptions > 0 ? ("warn" as const) : ("quiet" as const),
          },
        ]
      : []),
    { to: "/sites/redlist", label: "Red List", count: counts?.red_list },
  ];
  return <SubTabs label="Sites sections" tabs={tabs} end={end} />;
}
